import React from 'react';
import useRoomsCounterparties from '../../queries/useRoomsCounterparties';
import useAddField from '../../../../hooks/useAddField';
import SelectField from './SelectField';
import AddFieldsBtn from '../AddFieldsBtn/AddFieldsBtn';
import DeleteFieldBtn from '../DeleteFieldBtn/DeleteFieldBtn';
import { getReplacedString } from '../../../../helpers/getReplacedString';
import getName from '../../../../helpers/getName';

const OwnersSelectField = ({
  form,
  initialOwners,
  selectClassName,
  addFieldBtnClassName,
  hasLabel = true,
  getPopupContainer = () => document.body,
  options,
}) => {
  const { data: counterparties } = useRoomsCounterparties({
    staleTime: Infinity,
  });

  const { getFieldDecorator } = form;

  const hasLandLords = Boolean(initialOwners?.length);

  const {
    keys: landLordKeys,
    add: addLandLordField,
    remove: removeLandLordField,
  } = useAddField({
    form,
    name: 'landLordKeys',
    initialNumOfFields: hasLandLords ? initialOwners.length : 1,
  });

  return (
    <>
      {landLordKeys.map((key, index) => (
        <SelectField
          key={`${key}-${index}`}
          className={selectClassName}
          label={hasLabel && index === 0 ? 'Собственник' : ''}
          name={`landLord-${key}`}
          getFieldDecorator={getFieldDecorator}
          selectProps={{
            placeholder: 'Выбрать из списка',
            showSearch: true,
            optionFilterProp: 'children',
            allowClear: true,
            getPopupContainer,
            filterOption: (input, option) => {
              const value = getReplacedString(input);
              const name = getReplacedString(option.props.children);
              return name.includes(value);
            },
          }}
          getContent={(item) => item.name || getName(item)}
          items={counterparties}
          options={{
            initialValue: hasLandLords ? initialOwners[key]?.id : undefined,
            ...options,
          }}
          buttonComponent={
            index > 0 || hasLandLords ? (
              <DeleteFieldBtn onClick={() => removeLandLordField(key)} />
            ) : undefined
          }
        />
      ))}
      <AddFieldsBtn
        text="Добавить собственника"
        onClick={addLandLordField}
        className={addFieldBtnClassName}
      />
    </>
  );
};

export default OwnersSelectField;
